<!-- Modals -->
<app-deprecated-confirmation-dialog
    #confirmDeleteAssetDialog
    [label]="'company.assets.delete' | translate"
    [header]="'company.assets.deleteAssetTitle' | translate: { asset: currentAsset?.name }"
    [description]="'company.assets.deleteConfirmation' | translate"
    [negative]="true"
></app-deprecated-confirmation-dialog>

<app-deprecated-modal-form
    #assignAssetModal
    [form]="assignAssetForm"
    [label]="'company.assets.save' | translate"
    (save)="onAssignAsset(currentAsset.assignment)"
    (cancel)="onCancel()"
    headerText="{{ 'company.assets.assignAsset' | translate }}"
>
    <app-assign-asset #assignAssetForm [assetAssignment]="currentAsset.assignment"></app-assign-asset>
</app-deprecated-modal-form>

<app-deprecated-modal-form
    #reassignAssetModal
    [form]="reassignAssetForm"
    [label]="'company.assets.save' | translate"
    (save)="onAssignAsset(assetReassignment)"
    (cancel)="onCancel()"
    headerText="{{ 'company.assets.reassignAsset' | translate }}"
>
    <app-reassign-asset
        #reassignAssetForm
        [assetAssignment]="currentAsset.assignment"
        [assignee]="currentAsset.assignment?.employee"
        [assetReassignment]="assetReassignment"
    ></app-reassign-asset>
</app-deprecated-modal-form>

<!-- Body -->
<div class="page-container" [class.loading]="isLoading">
    <app-header title="{{ 'company.assets.company' | translate }}" [menuService]="companyMenuService">
        <div class="buttons" *ngIf="!table.isEmpty">
            <ui-button type="primary" url="new"
                ><mat-icon svgIcon="plus"></mat-icon>{{ 'company.assets.addAnAsset' | translate }}</ui-button
            >
        </div>
    </app-header>

    <div class="assets" *ngIf="!table.isEmpty; else emptyState">
        <!--show table if there are any assets-->
        <app-table [table]="table" (menuItemSelected)="onTableMenuEvent($event)">
            <app-empty-state label="{{ 'company.assets.noAssetsFound' | translate }}"></app-empty-state>
        </app-table>
    </div>

    <ng-template #emptyState>
        <!--empty state-->
        <div class="ui segment" style="position: relative">
            <div class="empty-state">
                {{ 'company.assets.youHaveNotCreatedAnyAssets' | translate }} <br />{{
                    'company.assets.createAssetsSoThatTheyCanBeTrackedWhenDistributedToEmployees' | translate
                }}
            </div>
            <div class="ui centered header add-button">
                <ui-button type="primary" url="new">{{ 'company.assets.addAnAsset' | translate }}</ui-button>
            </div>
        </div>
    </ng-template>
</div>
